/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_Calendly_DescInputs */

const en_privacy_section_5_calendly_desc = /** @type {(inputs: Privacy_Section_5_Calendly_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`booking links for scheduling consultations.`)
};

const lv_privacy_section_5_calendly_desc = /** @type {(inputs: Privacy_Section_5_Calendly_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`konsultāciju laika pieteikšana.`)
};

/**
* | output |
* | --- |
* | "booking links for scheduling consultations." |
*
* @param {Privacy_Section_5_Calendly_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_calendly_desc = /** @type {((inputs?: Privacy_Section_5_Calendly_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_Calendly_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_calendly_desc(inputs)
	return en_privacy_section_5_calendly_desc(inputs)
});